import IndexLinks from "../IndexLinks"

const HelpTopicAboutIndex = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
  ]

  const links = [
    { title: 'Premiers pas', link: '/topics/about/first-step'},
    { title: 'Fonctionnement de Wodzone', link: '/topics/about/fonctionnement'},
    { title: 'Conditions juridiques', link: '/topics/about/juridiques'}, 
  ]

  return <IndexLinks goBackLinks={goBackLinks} links={links}/>
}

export default HelpTopicAboutIndex